import logo from 'images/communities/Miami/logo.svg'
import secondaryLogo from 'images/communities/Miami/secondary-logo.svg'
import thirdLogo from 'images/communities/Miami/third-logo.svg'
import dashboardHeaderImage from 'images/communities/Miami/banner.jpg'
import loginBackgroundImg from 'images/communities/Miami/background-image.jpg'
import favicon from 'images/communities/Miami/favicon.png'
import homeLogo from 'images/home/community-logos/miami.png'
import { SURVEY_QUESTIONS } from 'types'
import videoImage from 'images/map/video/miami-video-button-image.png'

const config = {
  subdomain: 'miami',
  name: 'Miami',
  position: 9,
  partnerSupportEmail: 'artlook@miamifoundation.org',
  schoolSupportEmail: 'artlook@miamifoundation.org',
  artistSupportEmail: 'artlook@miamifoundation.org',
  stylesheet: 'miami.scss',
  mapRedirectPath: '',
  organizationUrl: 'https://miamifoundation.org/',
  secondaryOrganizationUrl: 'https://www3.dadeschools.net/home',
  thirdOrganizationUrl: 'https://www.artsaccessmiami.org/',
  faqUrl:
    'https://drive.google.com/file/d/1oH2dEra1lbFwANDTzFocMO8tRqQQ2Fby/view?usp=sharing',
  mapEnabled: true,
  schoolPortalEnabled: true,
  partnerPortalEnabled: true,
  partnerProfileCompletionEnabled: false,
  schoolProfileCompletionEnabled: false,
  teachingArtistProfileCompletionEnabled: false,
  showRecentLoginOnPublicPage: false,
  portalSignInEnabled: true,
  googleLoginEnabled: true,
  partnerProgramsEnabled: true,
  educatorEnabled: false,
  notificationsEnabled: true,
  notificationListSize: -1,
  dataDashboardEnabled: true,
  partnerRegisterEnabled: false,
  id: 45,
}

// ----- Teaching Artist -----
config.teachingArtist = {
  enabled: false,
  registerEnabled: false,
  provideOwnPrograms: false,
}

config.teachingArtistRegister = {
  fields: {
    firstName: {
      visible: true,
      required: true,
    },
    lastName: {
      visible: true,
      required: true,
    },
    email: {
      visible: true,
      required: true,
    },
    address: {
      visible: true,
      required: true,
    },
    yearsOfExperience: {
      visible: true,
      required: true,
    },
    description: {
      visible: true,
      required: true,
    },
    website: {
      visible: true,
      required: false,
    },
    disciplines: {
      visible: true,
      required: true,
    },
    profilePicture: {
      visible: true,
      required: false,
    },
    backgroundCheckFile: {
      visible: false,
      required: false,
    },
    pronouns: {
      visible: false,
      required: false,
    },
    demographic: {
      visible: false,
      required: false,
    },
    idealWage: {
      visible: true,
      required: false,
    },
  },
}

// ----- SEARCH -----
config.search = {
  options: {
    blockList: ['networks', 'creativeSchoolsCategory', 'instructorsTeaching'],
  },
  map: {
    center: { lat: 25.777679, lng: -80.192116 },
    radius: 40, //in miles
  },
  schoolSearchFilters: [
    'network',
    'creativeSchoolsCategory',
    'instructorsTeaching',
    'schoolType',
    'organizationPartnersCount',
    'programsOffered',
    'disciplineInterests',
    'resourceProgramOutcomeInterests',
    'coursesOffered',
    'studentDemographics',
    'schoolDistrict',
    'openToPartnerships',
  ],
  directoryFilters: {
    blockList: [
      'coursesOffered',
      'creativeSchoolsCategory',
      'instructorsTeaching',
      'partnerProgramTypes',
      'partnersCount',
      'programTypes',
      'resourceProgramOutcomeInterests',
      'resourceTypes',
      'schoolDistrict',
      'schoolTypes',
      'schoolYears',
      'studentDemographics',
      'subDisciplines',
      'schools',
      'topics',
      'users',
      'networks',
    ],
  },
  forumFilters: {
    blockList: [
      'coursesOffered',
      'creativeSchoolsCategory',
      'instructorsTeaching',
      'partnerProgramTypes',
      'partnersCount',
      'programTypes',
      'resourceProgramOutcomeInterests',
      'resourceTypes',
      'schoolDistrict',
      'schoolYears',
      'studentDemographics',
      'subDisciplines',
      'gradesServed',
      'networks',
      'neighborhoods',
    ],
  },
}

// ----- BRANDING -----

config.defaultBranding = {
  className: 'mia-community',
  favicon,
  mapLogo: {
    src: logo,
    alt: "Miami's homepage",
    link: config.organizationUrl,
  },
  videoImpage: {
    src: videoImage,
    alt: 'Video Image',
  },
  homeLogo: {
    src: homeLogo,
    alt: 'The Miami Foundation',
  },
  communityLogo: {
    src: logo,
    alt: 'Artlook Schools',
  },
  secondarySideBySideLogo: {
    src: secondaryLogo,
    alt: 'Miami Dade County Public Schools Seal',
    link: config.secondaryOrganizationUrl,
  },
  thirdSideBySideLogo: {
    src: thirdLogo,
    alt: 'Arts Access Miami',
    link: config.thirdOrganizationUrl,
  },
  dashboardHeader: {
    src: dashboardHeaderImage,
    alt: '',
  },
  loginBackgroundImg: {
    src: loginBackgroundImg,
    alt: '',
  },
  mapHero: {
    src: dashboardHeaderImage,
    alt: '',
  },
}

// ----- DISPLAY TEXT -----

/**
 * This object overrides the display text that is defined globally with string values that are
 * specific to the organization. Mustache-esque templating is available for dynamic strings using
 * {{ insertFieldName }} for interpolation.
 */

config.displayText = {
  map: {
    title: 'artlook Map: Bringing the power of the arts to ALL youth in Miami',
    searchHeader: 'Find Schools & Partners in Miami',
    welcomeSearchHeader: 'Explore Arts Education in Miami',
    welcomeHeader: `
      How Does artlook Help Arts Education in <span>${config.name}<span>?
    `,
    explorationHeader: '<h1>What can you do on artlook<sup>®</sup> Miami</h1>',
    explorationSubTitle: 'Here are some examples...',
    welcomeMessage: `
      <div class="columns">
        <div class="column-left">
          <p>
             Originally developed by Ingenuity in Chicago, artlook® has been locally customized through a collaboration 
             among Miami-Dade teachers, school and district administrators, arts partners, and Arts Access Miami staff. 
             The platform provides an up-to-date snapshot of the people, places, and programs that power arts education 
             in our community.
          </p>
        </div>
        <div class="column-right">
          <p>
            In addition to the public Map and Directory available on this site, artlook<sup>®</sup> ${config.name} 
            supports deeper data analysis, reporting, and coordination. These tools enable Arts Access Miami to 
            strengthen programming, drive investment, and support a thriving, equitable arts education ecosystem across 
            the county.    
          </p>
          <p>
            Arts Access Miami welcomes additional schools and arts partners to join artlook® Miami each year. 
            Learn more about us at 
            <a href="https://www.artsaccessmiami.org/" target="_blank" rel="noopener noreferrer">www.artsaccessmiami.org/</a>.
          </p
        </div>
      </div>
    `,
    findSchoolsCard: {
      title: `Find Schools`,
      text: `
        <p>
          If you’re an arts organization or teaching artist, search for schools in need of programs that you offer. 
          Reach out!
        </p>
        <p>
          If you’re a parent looking for an arts-rich or discipline-specific school for your child, find  schools that 
          provide what you’re looking for.
        </p>
      `,
    },
    findProgramsCard: {
      title: `Find Arts Programs & Organizations`,
      text: `
        <p>
          If you’re a school in need of arts programs, partnerships, or resources, search for arts orgs that provide what 
          you’re looking for. New arts ed partners are waiting to connect!
        </p>
      `,
    },
    findDataCard: {
      title: `Find Data`,
      text: `
        <p>
          If you’re an advocate for a stronger, more vibrant arts education landscape in ${config.name} reach out to 
          <a href="mailto:${config.schoolSupportEmail}" target="_blank" rel="noopener noreferrer">${config.schoolSupportEmail}</a>. 
          We provide data, programming, and other opportunities aimed at strengthening and expanding creative 
          opportunities for our region’s students.
        </p>
      `,
    },
    justExploreCard: {
      title: `Just Explore`,
      text: `
      <p>
        The artlook<sup>®</sup> ${config.name} Map contains the most comprehensive picture of arts ed in our region - 
        go search, explore, and learn more about the arts in our schools -- as well as where we need to bring more arts 
        to more students.
      </p>
    `,
    },
    videoWelcomeTitle: `Welcome To artlook<sup>®</sup> ${config.name}`,
    videoWelcomeMessage: `
      <p>
        Your Guide to Arts Education Partnerships in Miami-Dade Schools.      
      </p>
      <p>
        artlook<sup>®</sup> ${config.name} is a public resource that brings transparency to arts education across 
        Miami-Dade County Public Schools. As part of the Arts Access Miami initiative, a collaboration of schools, 
        nonprofits, and funders, this map helps identify where arts education is happening, who’s making it possible, 
        and where more support is needed.
      </p>
      <p>
        This tool supports a shared long-term vision: to ensure every student in every school has access to the 
        transformative power of the arts, no matter their ZIP code. 
      </p>
      <p>
        Developed in collaboration with local educators, cultural organizations, and national partners, this platform 
        showcases arts programs, partners, and opportunities—empowering communities to collaborate, invest, and act.
      </p>
      <p>
        Start exploring the map today. Together, we’re building a more creative, connected, and equitable future for 
        all students in Miami-Dade.
      </p>
    `,
    videoModal: {
      width: '560',
      height: '315',
      srcUrl:
        'https://www.youtube.com/embed/OeqCbofkUi8?si=988vOCj6wdLTqNEW&amp;controls=0',
      iframeTitle: 'Miami artlook map welcome video',
    },
    footer: {
      learnMoreAboutArtlook: 'Learn more about artlook<sup>®</sup>',
      contact: "We'd love to hear from you",
    },
    metricScore: {
      title: 'Creative Schools Certification',
      message: `
        The Creative Schools Certification is at the core of the CPS
        Arts Education Plan. It is a summary measure of the quality
        of arts education available in each school, and therefore
        functions as a decision-making roadmap for stakeholders
        working to expand the arts in schools.
      `,
      basedOnSchoolYear:
        ' The Certification information here is based on the {{ schoolYearNumber }} school year.',
    },
  },
  surveyCompletionModal: `
    <h2>Survey Complete!</h2>
    <br />
    <p>Thank you for completing this year's survey! Your responses help us paint a more comprehensive picture of arts education and can help us connect public schools such as yourselves with quality arts programs. You can download a copy of your survey responses on the survey page.</p>
    <br />
    <p><b>Next up: Give your Profile a quick refresh! Update your current year data to make sure everything's spot-on. The more accurate your info, the easier it is to connect with new partners and get discovered by the right ones.</b></p>
  `,
  tagline:
    'artlook Miami: Your Guide to Arts Education Partnerships in Miami-Dade Schools',
  partnerPortal: {
    dashboard: {
      welcomeMessage: `
      <h3>Transformative arts education begins with you</h3>
      <p>
        <em>artlook<sup>®</sup> Miami</em> combines data from Miami-Dade County Public Schools and arts education program providers (like you!). The more we know what programming is available to students inside and outside of school, the stronger we are able to support existing programs and help fill in the gaps to ensure equitable access to quality arts education programming for EVERY student in our community.
      </p>
      <p>Here's how you can contribute to this effort: </p>
      <ol class="bold-numbered bullet-inside">
        <li>
          <strong>Create and update your partner profile</strong>
          <p>Follow the links in the boxes below to share your organization's program and school partnership information. Make sure to complete all sections of your profile.</p>
          <p>If you have any questions or need assistance, please contact <a href="mailto:artlook@miamifoundation.org" target="_blank" rel="noopener noreferrer">artlook@miamifoundation.org</a>.</p>
        </li>
      </ol>
    `,
    },
  },
  schoolPortal: {
    dashboard: {
      welcomeMessage: `
        <h3>Transformative music education begins with you</h3>
        <p>
          <em>artlook<sup>®</sup> Miami</em> combines data from arts education program providers and Miami-Dade County Public Schools (like yours!). The more we know about the types of programming available to students inside and outside of school, the more we can support existing programs and ensure access to quality arts education programming for EVERY student in our community.
        </p>
        <p>
          <strong>
            To get started, complete both steps below: Update Your School Profile to share your partnership interests for the current school year, and Complete the Annual Survey (once it goes live) to share information about your school's arts education offerings from the previous school year.
          </strong>
        </p>
        <p>If you have any questions or need assistance, please contact <a href="mailto:${config.schoolSupportEmail}" target="_blank" rel="noopener noreferrer">${config.schoolSupportEmail}</a>.</p>
      `,
    },
  },
  survey: {
    getStarted: `<h2>Welcome to the {{ surveySchoolYearNumber }} artlook Survey!</h2>
    <p>Through this annual survey, you will be asked to share information about arts education instruction at your school and partnerships with arts partners (i.e. arts organizations).</p>
    <p>As you work on the {{ surveySchoolYearNumber }} survey, please be sure to frequently save your responses to each question to avoid losing information. You are not required to complete your survey in one session; saving your responses as you go will allow you to return at any time to complete or edit your survey before submitting by July 31st.</p>
    <p>Please feel free to reach out to <a href="mailto:${config.schoolSupportEmail}" target="_blank" rel="noopener noreferrer">${config.schoolSupportEmail}</a> with any questions!</p>`,
    staffingQuestion: {
      modalMessage: `
        <p>
        <strong>Note on instructors:</strong> Restrict the list of instructors in your school to those teaching an arts course during the school day. Note that district-run/district-managed schools require arts instructors to hold an ISBE certification or endorsement in one of the four state-recognized disciplines (visual arts, music, theater, and/or dance). Charter schools, contract schools, and Pre-K-only schools do not have this requirement. The media arts discipline does not have an ISBE certification/endorsement; these instructors should be listed as well.
        </p>
        <p>
        <strong>Note on part/full-time status:</strong> Please select Full Time if a teacher had full-time status for the entire school year. If a teacher was part-time for all or part of the year, or full-time for only part of the year, please select Part Time.
        </p>
        <p>
        <strong>Note on disciplines:</strong> The Primary Focus of each instructor is required. You may optionally list a Secondary Focus as well. Please also select the “Classroom/non-arts teacher?” button if the instructor is not primarily an arts instructor (e.g., non-arts, general education teacher teaching arts courses).
        </p>
        `,
      displayOptions: {
        showClassNumber: true,
      },
    },
    districtSpending: {
      question: `How much funding did your school allocate to the arts in {{surveySchoolYearNumber}}?`,
      description: `This is the amount of funding that your school used for arts education supplies, materials, and programs. Do not include outside funding sources, teacher salaries, or capital expenses.`,
    },
    instructorQuestion: {
      displayOptions: {
        showInstructorEmail: false,
      },
    },
    scholarshipQuestion: {
      displayOptions: {
        showExample: true,
      },
    },
    partnershipQuestion: {
      additionalTipsModal: `
        <p>
          Some arts partners may have already reported their partnerships with us, and those will appear here.
        </p>
        <p>
          You may add or delete new partnerships created by you, but not partnerships reported to us by organizations or teaching artists.        </p>
        <p>
          If you cannot find a partner from our search box or would like to delete a partnership reported by a partner, then please email us at  <a href="mailto:${config.schoolSupportEmail}" target="_blank" rel="noopener noreferrer">${config.schoolSupportEmail}!</a>
        </p>
        <p>
          The primary focus of this section is to track external arts partnerships. If a teacher at your school or the school itself is providing additional arts programming before or after school, please select ‘School-Provided Arts Programming’ as the name of the partner and choose Out-of-School Time (OST) as the program type. You may select more than one program type, but you may only enter ‘School-Provided Arts Programming’ once.
        </p>
      `,
    },
  },
  artistPortal: {
    dashboard: {
      welcomeMessage: `
        <h3>Welcome to artlook – A Home for Teaching Artists!</h3>
        <p>
          We're excited to have you join our vibrant community of teaching artists, educators, and organizations passionate about arts education. Whether you're here to showcase your talents, connect with schools and partners, or discover new opportunities, this platform is designed to support your journey
        </p>
        <p>
          Start by building your profile, sharing your experience, and exploring collaborations. Together, we can inspire creativity and make a lasting impact through the arts.
        </p>
        <p>
        If you have any questions or need assistance, please contact <a href="mailto:${config.artistSupportEmail}" target="_blank" rel="noopener noreferrer">${config.artistSupportEmail}</a>.
        </p>
      `,
    },
  },
}

// ----- SURVEY QUESTIONS CONFIG -----

const {
  APPROACHES,
  GOVERNANCE,
  OBSTACLES_SELECT,
  OBSTACLES_DESCRIBE,
  DISTRICT_SPENDING,
  OBSTACLES_OVERCOME,
  COMMUNITY_ENGAGEMENTS,
} = SURVEY_QUESTIONS

config.surveyQuestions = {
  approaches: APPROACHES.OPTIONS.GENERAL,
  governance: GOVERNANCE.OPTIONS.GENERAL,
  obstaclesSelect: OBSTACLES_SELECT.OPTIONS.GENERAL,
  districtSpending: DISTRICT_SPENDING.OPTIONS.GENERAL,
  obstaclesDescribe: OBSTACLES_DESCRIBE.OPTIONS.GENERAL,
  obstaclesOvercome: OBSTACLES_OVERCOME.OPTIONS.GENERAL,
  communityEngagement: COMMUNITY_ENGAGEMENTS.OPTIONS.GENERAL,
}

// ----- EDUCATOR CONFIG -----

config.educator = {
  communityOfPracticeEnabled: false,
}

export default config
